import { render, staticRenderFns } from "./BtnAtualizarDotacao.vue?vue&type=template&id=1ed8dca6"
import script from "./BtnAtualizarDotacao.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarDotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports